import isEqual from "lodash/isEqual";
import snakeCase from "lodash/snakeCase";
import classNames from "classnames";
import PropTypes from "prop-types";
import React, { Component } from "react";

import ActionBarButton from "./ActionBarButton";

/*
 * HEADS UP!
 *
 * This component implements its own shouldComponentUpdate. So if something it's
 * not working correctly or the component is not updating itself, make sure to
 * check that methdod.
 */

class ActionBar extends Component {
    componentDidMount() {
        setTimeout(this.props.scrollMessageListToBottom, 0);
        this.props.setOffsetBottomOfMessageList();
    }

    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps.buttons, this.props.buttons) || nextProps.isLoading !== this.props.isLoading;
    }

    componentDidUpdate() {
        setTimeout(this.props.setOffsetBottomOfMessageList, 0);
    }

    componentWillUnmount() {
        setTimeout(this.props.setOffsetBottomOfMessageList, 0);
    }

    render() {
        const { buttons, isLoading } = this.props;
        const actionBarClasses = classNames({
            ActionBar: true,
            "ActionBar--fullWidth": buttons.length > 2,
        });

        return (
            <div className={actionBarClasses}>
                {buttons.map(({ label, onClick }) => (
                    <ActionBarButton key={snakeCase(label)} isDisabled={isLoading} label={label} onClick={onClick} />
                ))}
            </div>
        );
    }
}

ActionBar.propTypes = {
    buttons: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            onClick: PropTypes.func.isRequired,
        })
    ).isRequired,
    isLoading: PropTypes.bool.isRequired,
    scrollMessageListToBottom: PropTypes.func.isRequired,
    setOffsetBottomOfMessageList: PropTypes.func.isRequired,
};

export default ActionBar;
